import { Cartesian3, IntersectionTests, Plane } from "cesium";
import { EarthBrainUtils } from "../utilities/earthbrainutility";
export class ZBoundedPlane extends Plane {
    hasBounds;
    topLeft;
    topRight;
    bottomLeft;
    bottomRight;
    /**
     *
     * @param normal should be parallel to xy plane, z = 0
     * @param distance
     * @param bounds
     */
    constructor(normal, distance, bounds) {
        if (normal.z !== 0) {
            console.warn(`z of normal of plane is ${normal.z}`);
        }
        super(normal, distance);
        if (bounds) {
            this.computeBounds(bounds);
        }
    }
    computeBounds(bounds) {
        this.hasBounds = true;
        const upDir = Cartesian3.UNIT_Z;
        const downDir = Cartesian3.negate(upDir, new Cartesian3());
        const leftDir = new Cartesian3();
        Cartesian3.cross(upDir, this.normal, leftDir);
        const rightDir = Cartesian3.negate(leftDir, new Cartesian3());
        const top = Cartesian3.multiplyByScalar(upDir, bounds.height / 2, new Cartesian3());
        const bottom = Cartesian3.multiplyByScalar(downDir, bounds.height / 2, new Cartesian3());
        const left = Cartesian3.multiplyByScalar(leftDir, bounds.width / 2, new Cartesian3());
        const right = Cartesian3.multiplyByScalar(rightDir, bounds.width / 2, new Cartesian3());
        this.topLeft = Cartesian3.add(top, left, new Cartesian3());
        this.bottomLeft = Cartesian3.add(bottom, left, new Cartesian3());
        this.topRight = Cartesian3.add(top, right, new Cartesian3());
        this.bottomRight = Cartesian3.add(bottom, right, new Cartesian3());
        if (this.distance !== 0) {
            const center = Cartesian3.multiplyByScalar(this.normal, this.distance, new Cartesian3());
            this.topLeft = Cartesian3.add(center, this.topLeft, this.topLeft);
            this.bottomLeft = Cartesian3.add(center, this.bottomLeft, this.bottomLeft);
            this.topRight = Cartesian3.add(center, this.topRight, this.topRight);
            this.bottomRight = Cartesian3.add(center, this.bottomRight, this.bottomRight);
        }
    }
    /**
     *
     * @param point Cartesian3
     * @param normal should be parallel to xy plane, z = 0
     * @param result Plane
     * @returns
     */
    static fromPointNormal(point, normal, result, bounds) {
        const plane = super.fromPointNormal(point, normal, result);
        result = new ZBoundedPlane(plane.normal, plane.distance, bounds);
        return result;
    }
    raycast(ray) {
        if (!EarthBrainUtils.isValidRay(ray)) {
            console.warn("Invalid ray");
            return undefined;
        }
        let result;
        if (this.hasBounds) {
            let triangleHit = IntersectionTests.rayTriangle(ray, this.topLeft, this.bottomLeft, this.bottomRight); //counterclockwise
            if (!triangleHit) {
                triangleHit = IntersectionTests.rayTriangle(ray, this.topLeft, this.bottomRight, this.topRight); //counterclockwise
            }
            result = triangleHit;
        }
        else {
            result = IntersectionTests.rayPlane(ray, this);
        }
        if (!result) {
            //check if ray origin is on the plane
            const projectedPoint = Plane.projectPointOntoPlane(this, ray.origin);
            if (Cartesian3.distance(projectedPoint, ray.origin) < 0.0001) {
                result = ray.origin;
            }
        }
        return result;
    }
}
//# sourceMappingURL=z-bounded-plane.js.map